const ArrowIcon: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.2873 13.31L10.8244 19.7729C10.5606 20.0367 10.434 20.3444 10.4446 20.6962C10.4551 21.0479 10.5927 21.3556 10.8574 21.6194C11.1212 21.8612 11.429 21.9879 11.7807 21.9993C12.1324 22.0107 12.4401 21.8841 12.7039 21.6194L21.409 12.9143C21.5409 12.7824 21.6346 12.6396 21.69 12.4857C21.7454 12.3318 21.7722 12.1669 21.7704 11.9911C21.7687 11.8152 21.741 11.6503 21.6873 11.4965C21.6337 11.3426 21.5405 11.1997 21.4077 11.0678L12.7026 2.36271C12.4608 2.1209 12.1583 2 11.7952 2C11.432 2 11.119 2.1209 10.8561 2.36271C10.5923 2.6265 10.4604 2.93997 10.4604 3.30313C10.4604 3.66628 10.5923 3.97931 10.8561 4.24222L17.2873 10.6721H2.548C2.1743 10.6721 1.86082 10.7987 1.60759 11.052C1.35435 11.3052 1.22816 11.6182 1.22904 11.9911C1.22992 12.3639 1.35654 12.6774 1.6089 12.9315C1.86126 13.1856 2.1743 13.3118 2.548 13.31H17.2873Z"
                fill="#101820"
            />
        </svg>
    )
}

ArrowIcon.displayName = 'ArrowIcon'

export default ArrowIcon
